'use strict';

app.controller('GroupsCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$state',
    '$ngConfirm',
    'toaster',
    function($scope, $http, $translate, $state, $ngConfirm, toaster) {
        $scope.LOGINS_TAB = 1;
        $scope.GROUPS_TAB = 2;

        $scope.tab = $scope.OBJECTS_TAB;
        $scope.form = false;

        $scope.loading = false;
        $scope.logins = [];
        $scope.objects = angular.copy($scope.extractAllUserObjects(false, false));

        $scope.selected = {
            group: {
                name: '',
                code: '',
                comment: '',
                color: 'FFFFFF',
            },
            related: {
                args: {},
            },
        };
        $scope.initial = angular.copy($scope.selected);

        $scope.changeTab = function(v) {
            $scope.form = false;
            $scope.tab = v;
        };
        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };
        $scope.toggleForm = function() {
            $scope.form = !$scope.form;
        };
        $scope.isVisibleForm = function() {
            return $scope.form;
        };
        $scope.deleteConfirmation = function(group) {
            $ngConfirm({
                title: $translate.instant('general.confirm.delete.title'),
                content:
                    $translate.instant('general.confirm.delete.content') +
                    '<b> (' +
                    group.name +
                    ') </b>',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-trash pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.delete.yes'),
                        btnClass: 'btn-danger',
                        action: function(scope) {
                            scope.deleteGroup(group.groupId);
                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.delete.no'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };
        $scope.deleteGroup = function(id) {
            $http.post('/api/group/delete/', { id: id }).then(function() {
                $scope.afterFormAction();
            });
        };
        $scope.saveGroup = function(obj) {
            var payload = obj ? obj : $scope.selected.group;

            if (!payload.name) {
                toaster.pop(
                    'error',
                    $translate.instant('service.toastr.error.header'),
                    $translate.instant('groups.toastr.error.fillup')
                );
                return false;
            }

            if (payload.color === 'FFFFFF') {
                delete payload.color;
            }

            $http.post('/api/group/save', payload).then(function() {
                $scope.afterFormAction();
                // !obj && $scope.resetGroupForm();
            });
        };
        $scope.associateGroup = function(obj) {
            var payload = $scope.beforeAssociateGroup(obj);

            $http.post('/api/group/associate', payload).then(function() {
                $scope.afterFormAction();
            });
        };
        $scope.afterFormAction = function() {
            /**
             * currently reloads after change
             */

            $state.go($state.current, {}, { reload: true });
        };
        $scope.resetGroupForm = function() {
            $scope.selected.group = angular.copy($scope.initial.group);
        };
        $scope.getGroups = function() {
            $scope.loading = true;
            $http.get('/api/group/list').then(
                function(response) {
                    $scope.groups = response.data.data.groups;
                    angular.forEach($scope.groups, function(o) {
                        if (o.color === void 0) {
                            o.color = 'FFFFFF';
                        }
                    });
                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.beforeAssociateGroup = function(group) {
            var payload = {
                groupId: group.groupId,
                objects: group.objects.map(function(v) {
                    return v.objectId;
                }),
            };
            return payload;
        };

        $scope.init = function() {
            $scope.getGroups();
        };
        $scope.init();
    },
]);
